import { doGet } from '../services/http';
import { getUserRole } from './urls';

export const fetchAuthenticationDetail = url => doGet(`${url}${getUserRole}`);
